import React, { useContext, useMemo } from 'react';
import { TabPane, Tabs, Text, theme } from 'components';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';
import { TabMenu } from './types';
import AnsweringSearchContext from './AnsweringSearchContext';
import AnsweringBrokerageTable from './AnsweringBrokerageTable';
import AnsweringAgentTable from './AnsweringAgentTable';
import MlsStaffRightHeader from './MlsStaffRightHeader';

const AnsweringSearchLayout = () => {
  const { selectedTab, setSelectedTab, orgType } = useContext(
    AnsweringSearchContext,
  );
  const { md } = useBreakpoint();
  const tabPaneList = useMemo(
    () => [
      {
        key: TabMenu.Brokerages,
        label: TabMenu.Brokerages,
        content: <AnsweringBrokerageTable />,
      },
      {
        key: TabMenu.Agents,
        label: TabMenu.Agents,
        content: <AnsweringAgentTable />,
      },
    ],
    [],
  );

  return (
    <Tabs
      activeKey={selectedTab}
      onTabClick={key => setSelectedTab(key as TabMenu)}
      tabBarStyle={{ margin: 0, padding: `0 ${md ? 20 : 10}px` }}
      tabBarGutter={md ? 32 : 20}
      destroyInactiveTabPane
      {...(orgType === 'mlsStaff' && {
        tabBarExtraContent: {
          right: <MlsStaffRightHeader />,
        },
      })}
    >
      {tabPaneList.map(({ key, label, content }) => (
        <TabPane
          key={key}
          tab={
            <StyledPaneTitle
              $active={key === selectedTab}
              data-cy={`answering-tab-${key}`}
            >
              {label}
            </StyledPaneTitle>
          }
        >
          {content}
        </TabPane>
      ))}
    </Tabs>
  );
};

const StyledPaneTitle = styled(Text)<{ $active: boolean }>`
  color: ${({ $active }) =>
    $active ? theme.getColor('primary') : theme.getColor('textSecondary')};
`;

export default AnsweringSearchLayout;
